import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { CardStack } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import SourceSettings from './SourceSettings';

const ProjectSettings = ({ settings, saveSettings }) => {
  const panels = [];

  const buildSourcePanel = (assetSettings, assetIndex) =>
    (
      <CardStack
        icon="schema"
        title={intl.formatMessage(messages.projectSettingsAssets)}
        description={intl.formatMessage(messages.projectSettingsDescription)}
      >
        <SourceSettings
          index={assetIndex}
          settings={assetSettings}
          saveSettings={saveSettings}
        />
      </CardStack>
    );

  if (settings && settings.assets) {
    settings.assets.forEach((asset, ix) => {
      const section = buildSourcePanel(asset, ix);
      panels.push(<div key={`settings${asset.title}`}>
        {section}
      </div>);
    });
  } else {
    const asset = { sourceType: 'none', title: '', documentLibraryId: '' };
    const section = buildSourcePanel(asset, 0);
    panels.push(<div key={'settingsEmpty'}>
      {section}
    </div>);
  }

  return (
    <div>
      {panels.length && panels}
    </div>
  );
};

ProjectSettings.propTypes = {
  settings: PropTypes.object,
  saveSettings: PropTypes.func,
};

export default withTheme(ProjectSettings);
